import React from 'react';
import { MapPin } from 'lucide-react';
import { Store } from '../types';
interface PolaroidCardProps {
  store: Store;
  rotation?: number;
  size?: 'sm' | 'md' | 'lg';
  caption?: string;
  showTape?: boolean;
  className?: string;
  style?: React.CSSProperties;
}
const sizeMap = {
  sm: {
    card: 'w-28',
    img: 'h-24',
    text: 'text-[10px]',
    cap: 'text-xs'
  },
  md: {
    card: 'w-40',
    img: 'h-36',
    text: 'text-xs',
    cap: 'text-sm'
  },
  lg: {
    card: 'w-56',
    img: 'h-52',
    text: 'text-sm',
    cap: 'text-base'
  }
};
export function PolaroidCard({
  store,
  rotation = 0,
  size = 'md',
  caption,
  showTape = false,
  className = '',
  style
}: PolaroidCardProps) {
  const s = sizeMap[size];
  return <div className={`relative bg-white p-2 pb-7 shadow-lg ${s.card} ${className}`} style={{
    transform: `rotate(${rotation}deg)`,
    boxShadow: '0 8px 20px -4px rgba(0,0,0,0.18), 0 2px 4px -2px rgba(0,0,0,0.1)',
    ...style
  }} data-id="element-153">
      {showTape && <div className="absolute -top-2 left-1/2 w-10 h-4 bg-[#FFFC00]/80 z-10" style={{
      transform: 'translateX(-50%) rotate(-3deg)'
    }} data-id="element-154" />}
      <div className={`w-full ${s.img} bg-gray-100 overflow-hidden`} data-id="element-155">
        <img src={store.image} alt={store.name} className="w-full h-full object-cover" data-id="element-156" />
      </div>
      <div className="pt-2 px-1" data-id="element-157">
        <p className={`font-bold text-gray-900 truncate ${s.cap}`} style={{
        fontFamily: "'Caveat', 'Permanent Marker', cursive"
      }} data-id="element-158">
          {caption || store.name}
        </p>
        <p className={`${s.text} text-gray-500 flex items-center gap-0.5 truncate`} data-id="element-159">
          <MapPin size={9} className="flex-shrink-0" data-id="element-160" />
          <span className="truncate" data-id="element-161">{store.distance}</span>
        </p>
      </div>
    </div>;
}